import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
const MsgApp = React.lazy(() => import("./MsgApp"));

function decodeURL() {
  if (!window.location.href.split("?")[1]) {
    console.log("No data passed in to Chat element :(.");
    return;
  }
  var params = window.location.href.split("?")[1].split("&");
  var data = {};
  for (var x in params) {
    data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
  }
  return data;
}
var parent_location,
  parent_title,
  gid,
  iid,
  pid,
  mobile,
  parent_referrer,
  defaultOpen,
  position,
  customStyle,
  previewMode;
var data = decodeURL();
if (data) {
  parent_referrer = data.referrer;
  parent_location = data.location;
  parent_title = data.title;
  gid = data.gid;
  pid = data.pid;
  iid = data.iid;
  mobile = data.mobile;
  defaultOpen = data.open ? true : false;
  previewMode = data.preview ? data.preview : false;
  position = data.position === "left" ? "chat_area_left" : "chat_area";
  customStyle = data.custom ? "custom" : "";
}

if (!gid || !iid) {
  gid = "73574010-2f33-4b41-8b8a-09d18b025a56"
  mobile = true;
  iid = '1ae35252-799c-41a0-b2a6-c086ccf68f25';
  defaultOpen = false;
  position = "chat_area";
  customStyle = "";
}
// Make sure frame is open when the bot is being interacted with (see chatplugin.js)
window.addEventListener("click", () => {
  window.postMessage("messengerwindowOpen");
});

ReactDOM.render(
  <Provider store={store}>
  <Suspense fallback={
    <div id="spinner" className="container">
      <div className="loading"></div>
    </div>}>
    <MsgApp
      parent_location={parent_location}
      parent_title={parent_title}
      parent_referrer={parent_referrer}
      gid={gid}
      iid={iid}
      pid={pid}
      mobile={mobile}
      defaultOpen={defaultOpen}
      position={position}
      customStyle={customStyle}
      previewMode={previewMode}>
    </MsgApp>
  </Suspense>
  </Provider>
  ,
  document.getElementById("root")
);
